import profile from './main-profile-3.jpg'

const Images = {
    profile: profile,
}

export default Images